import { costProfileCostsHistory } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveCostProfileCostsHistoryRequestFailure({ uuid }) {
      const req = getState().find(
        ({ costProfile }) => costProfile.uuid === uuid,
      );

      return req ? req.request.isFailure : false;
    },
    isRetrieveCostProfileCostsHistoryRequestPending({ uuid }) {
      const req = getState().find(
        ({ costProfile }) => costProfile.uuid === uuid,
      );

      return req ? req.request.isPending : false;
    },
    isRetrieveCostProfileCostsHistoryRequestSuccess({ uuid }) {
      const req = getState().find(
        ({ costProfile }) => costProfile.uuid === uuid,
      );

      return req ? req.request.isSuccessful : false;
    },
    getCostProfileCostsHistory({ uuid }) {
      const req = getState().find(
        ({ costProfile }) => costProfile.uuid === uuid,
      );

      return req ? req.history : costProfileCostsHistory;
    },
  };
}

export { createSelector };
